import { SettingsContent } from "./settings";
import { Link, DestructuredURL, DVString } from "./shared";

export interface DoubleBillingOutput extends SettingsContent {
    warning?: string;
}

export interface MembershipPaymentWidgetOutput extends SettingsContent {
    memberships: MembershipPaymentModel[];
}

export enum MembershipPaymentTypes {
    NoMembershipModel = 'atv.wps#NoMembershipModel',
    DifferentMarketplaceMembershipModel = 'atv.wps#DifferentMarketplaceMembershipModel',
    RetailMembershipModel = 'atv.wps#RetailMembershipModel',
    PendingCancelAmazonROWMembershipModel = 'atv.wps#PendingCancelAmazonROWMembershipModel',
    ActiveAmazonROWMembershipModel = 'atv.wps#ActiveAmazonROWMembershipModel',
    FuseMembershipModel = 'atv.wps#FuseMembershipModel',
    GoogleMembershipModel = 'atv.wps#GoogleMembershipModel',
    AppleMembershipModel = 'atv.wps#AppleMembershipModel',
}

export interface MembershipPaymentModel {
    __type: MembershipPaymentTypes;
}

export enum MembershipManageMethodTypes {
    MembershipManageMessage = 'atv.wps#MembershipManageMessage',
    MembershipManageButton = 'atv.wps#MembershipManageButton',
    MembershipRenewalUpdateButton = 'atv.wps#MembershipRenewalUpdateButton'
}

export interface MembershipManageMethod {
    __type: MembershipManageMethodTypes;
}

export interface MembershipManageMessage extends MembershipManageMethod {
    text: string;
}

export interface MembershipRenewalUpdateButton extends MembershipManageMethod {
    text: string;
    formData: DestructuredURL;
}

export interface MembershipManageButton extends MembershipManageMethod {
    text: string;
    href: string;
    buttonType: ButtonType;
    disabled: boolean;
}

export enum CustomerPaymentInstrumentTypes {
    AmazonCustomerPaymentInstrument = 'atv.wps#AmazonCustomerPaymentInstrument',
    AmazonCustomerPaymentMessage = 'atv.wps#AmazonCustomerPaymentMessage',
    ExternallyManagedPaymentInstrument = 'atv.wps#ExternallyManagedPaymentInstrument',
    GooglePlayPayment = 'atv.wps#GooglePlayPayment',
    ITunesPayment = 'atv.wps#ITunesPayment'
}

export interface CustomerPaymentInstrument {
    __type: CustomerPaymentInstrumentTypes;
}

export interface AmazonCustomerPaymentInstrument extends CustomerPaymentInstrument {
    label: string;
    html?: string;
    emptyMessage?: string;
}

export interface AmazonCustomerPaymentMessage extends CustomerPaymentInstrument {
    message: string;
}

export interface ExternallyManagedPaymentInstrument extends CustomerPaymentInstrument {
    label: string;
    name: string;
    logo: PaymentInstrumentLogo;
}

export interface ITunesPayment extends ExternallyManagedPaymentInstrument {
    updateInfo?: string;
}

export interface GooglePlayPayment extends ExternallyManagedPaymentInstrument {}

export enum ChannelsPaymentForExternalMembershipTypes {
    ChannelsPaymentMessageOnly = 'atv.wps#ChannelsPaymentMessageOnly',
    ChannelsPaymentView = 'atv.wps#ChannelsPaymentView'
}

export interface ChannelsPaymentForExternalMembership {
    __type: ChannelsPaymentForExternalMembershipTypes;
    header: string;
}

export interface ChannelsPaymentMessageOnly extends ChannelsPaymentForExternalMembership {
    message: string;
}

export interface ChannelsPaymentView extends ChannelsPaymentForExternalMembership {
    paymentInstrument: AmazonCustomerPaymentInstrument;
    paymentManagementsMethods: PaymentManageMethod[];
}

export interface PaymentManageMethod {
    text: string;
    href: string;
    buttonType: ButtonType;
}

export enum PaymentInstrumentLogo {
    ITunesLogo = "iTunes",
    GooglePlayLogo = "GooglePlay"
}

export enum ButtonType {
    SignUp = "sign-up",
    ViewNewTab = "view-new-tab",
    ViewInPlace = "view-in-place"
}

export interface GoogleMembershipModel extends MembershipPaymentModel {
    header: string;
    action?: MembershipManageButton;
    terms?: Link;
    paymentInstrument: GooglePlayPayment;
    paymentManagementsMethods: PaymentManageMethod[];
    channelsPayment?: ChannelsPaymentForExternalMembership
}

export interface AppleMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage?: DVString;
    action?: MembershipManageButton;
    terms?: Link;
    paymentInstrument: ITunesPayment;
    paymentManagementsMethods: PaymentManageMethod[];
    channelsPayment?: ChannelsPaymentForExternalMembership
}

export interface FuseMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage?: DVString;
    action?: MembershipManageButton;
}

export interface ActiveAmazonROWMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage?: DVString;
    action?: MembershipManageButton;
    terms?: Link;
    paymentInstrument: CustomerPaymentInstrument;
    paymentManagementsMethods: PaymentManageMethod[];
}

export interface PendingCancelAmazonROWMembershipModel extends MembershipPaymentModel {
    header: string;
    pendingCancellationWarning: string;
    membershipMessage?: DVString;
    action?: MembershipRenewalUpdateButton;
    terms?: Link;
    paymentInstrument: CustomerPaymentInstrument;
    paymentManagementsMethods: PaymentManageMethod[];
}

export interface RetailMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage?: DVString;
    action: MembershipManageMethod;
    paymentInstrument: AmazonCustomerPaymentInstrument;
    channelsPaymentMessage?: String;
}

export interface NoMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage: DVString;
    action?: MembershipManageButton;
}

export interface DifferentMarketplaceMembershipModel extends MembershipPaymentModel {
    header: string;
    membershipMessage: DVString;
    action: MembershipManageButton;
}
